// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "062f9cc6b95c5f40ae3e" + ".css";
};